module.exports = __webpack_public_path__ + "static/img/tu10.7e4ac03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tu10.png
// module id = JaHn
// module chunks = 10